/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import { createReducer } from 'state/utils';
import {
    LOGIN_REQUEST,
    LOGIN_REQUEST_FAILURE,
    LOGIN_REQUEST_SUCCESS,
    LOGIN_AUTH_VERIFY_USER_REQUEST_SUCCESS,
    LOGIN_AUTH_VERIFY_USER_REQUEST,
    LOGIN_AUTH_VERIFY_USER_REQUEST_FAILURE,
    LOGIN_AUTH_VERIFY_USER_RESET
} from 'state/action-types';

export const isRequesting = createReducer(false, {
    [LOGIN_REQUEST]: () => true,
    [LOGIN_REQUEST_FAILURE]: () => false,
    [LOGIN_REQUEST_SUCCESS]: () => false,
});

export const requestSuccess = createReducer(null, {
    [LOGIN_REQUEST]: () => null,
    [LOGIN_REQUEST_FAILURE]: () => false,
    [LOGIN_REQUEST_SUCCESS]: () => true,
});

export const requestError = createReducer(null, {
    [LOGIN_REQUEST]: () => null,
    [LOGIN_REQUEST_FAILURE]: (state, { error }) => error,
    [LOGIN_REQUEST_SUCCESS]: () => null,
    [LOGIN_AUTH_VERIFY_USER_REQUEST_FAILURE]: (state, { error }) => error,
});

export const verifiedAccount = createReducer(null, {
    [LOGIN_AUTH_VERIFY_USER_RESET]: (state, action) => null,
    [LOGIN_AUTH_VERIFY_USER_REQUEST_SUCCESS]: (state, action) => action.payload.usernameOrEmail,
    [LOGIN_AUTH_VERIFY_USER_REQUEST_FAILURE]: (state, action) => null,
    [LOGIN_AUTH_VERIFY_USER_REQUEST]: () => null,
});

export default combineReducers({
    isRequesting,
    requestError,
    requestSuccess,
    verifiedAccount,
});
